import React from "react";
import { interpolate } from "../shared/utils/legacy";

interface DocCardProperties {
  documentKey: string;
  documentFileType: string;
  clickDocument?: (attachmentKey: string) => void;
  size?: 25 | 128;
  center?: boolean;
  iconColor?: "white" | "black";
  className?: string;
}

const DocCard = ({
  documentKey,
  documentFileType,
  clickDocument,
  size = 128,
  center = true,
  iconColor = "white",
  className,
}: DocCardProperties) => {
  let docIcon = "fa-file";
  ["excel", "word", "pdf"].map((filetype) => {
    if (documentFileType.includes(filetype)) {
      docIcon = interpolate("fa-file-%s", [filetype]);
    }
    return null;
  });

  return (
    <div
      onClick={() => clickDocument?.(documentKey)}
      className={`attachment-thumb h-${size}px overflow-hidden ${
        center ? "bg-smoke d-flex align-items-center justify-content-center" : ""
      }`}
    >
      <i className={`fal ${docIcon} text-${iconColor} ${className}`}></i>
    </div>
  );
};
export default DocCard;
